/** Resized/compressed public assets — keep in sync with scripts/optimize-homepage-images.mjs */

export const CONTACT_US_IMAGE = '/Images/contactus-image.webp';
export const CONTACT_US_IMAGE_WIDTH = 950;
export const CONTACT_US_IMAGE_HEIGHT = 950;

export const LOGO_IMAGE_WEBP = '/Images/ppp-orange-Blue-logo.webp';
export const LOGO_IMAGE_PNG = '/Images/ppp-orange-Blue-logo.png';
export const LOGO_IMAGE_WIDTH = 600;
export const LOGO_IMAGE_HEIGHT = 179;

export const PROCESS_BG_WEBP = '/homepageimages/process.webp';
export const PROCESS_BG_JPG = '/homepageimages/process.jpg';
export const CASE_PACKAGING_BG = '/Images/OPTIMIZED-CASE-PACKAGING.webp';
